import React from "react";
import BlogComponent from "../components/BlogComponent";
function Gallery()
{
  return(
    <div>
    <div style={{ marginTop: '90px' }}>
    <BlogComponent/>
</div>
</div>
  );

}

export default Gallery;